import React,{Component} from "react";
import {

  Row,
  Col,
 
  Form,
  FormInput,

  FormGroup,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Button,

  DatePicker
} from "shards-react";

export default class AddFees extends Component{
  render(){


    var name = (this.props.selected_student!==undefined)?this.props.selected_student.name:'N/A';
    var class_name = (this.props.selected_student!==undefined)?this.props.selected_student.class:'N/A';
    var roll_no = (this.props.selected_student!==undefined)?this.props.selected_student.roll_no:'N/A';

    var fees_paid = (this.props.fees_paid!==undefined)?this.props.fees_paid:"0000";
    var total_fee = (this.props.total_fee!==undefined)?this.props.total_fee:"0000";
    var date = this.props.date;

    return(


      <div>      
      <Row className="border-bottom py-2 bg-light">
            <Col sm="12" className="d-flex mb-2 mb-sm-0">
              <Col md="4">
                {"Name : "+name}
              </Col>

              <Col md="4">
                  {"Class : "+class_name}
              </Col>

              <Col md="4">
                 {"Roll No : "+roll_no}
              </Col>

            </Col>
            
          </Row>

         
    <Col className="mb-0" lg="12" style={{marginTop: '2%'}}>
      
    <strong className="text-muted d-block mb-2">Fees</strong>
    <Form>
      <FormGroup>
        <InputGroup className="mb-3">
          <InputGroupAddon type="prepend">
            <InputGroupText>Fees Paid</InputGroupText>
          </InputGroupAddon>
          <FormInput placeholder={fees_paid} onChange={(evt)=>{ this.props.setFeePaid(evt.target.value) }}/>
        </InputGroup>
      </FormGroup>
  

      <FormGroup>
        <InputGroup className="mb-3">
          <InputGroupAddon type="prepend">
            <InputGroupText>Total Fees</InputGroupText>
          </InputGroupAddon>
          <FormInput placeholder={total_fee} onChange={(evt)=>{ this.props.setTotalFee(evt.target.value) }}/>
        </InputGroup>
      </FormGroup>

      <FormGroup>
        <InputGroup className="mb-3">
          <InputGroupAddon type="prepend">
            <InputGroupText>Last__Date</InputGroupText>
          </InputGroupAddon>
          <DatePicker placeholderText={date} onChange={this.props.handleDateChange}/>
        </InputGroup>
      </FormGroup>      

    </Form>


    <Col className="mb-2" style={{alignSelf: 'center',marginTop: '4%' }}>
        
        <Button theme="info" size="sm" style={{marginLeft: '2%'}} onClick={this.props.update_fee_details}>Save</Button>
    </Col>
  </Col>  

  </div>
      )
  }
}